<template>
  <v-btn color="primary" :disabled="disabled" :loading="loading" type="submit" @click="$emit('click', $event)">
    {{ label }}
  </v-btn>
</template>

<script>
  export default {
    name: 'BotaoConfirmarTarefa',

    props: {
      label: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
